
import {writable} from 'svelte/store';

const store = writable([]);

store.getAll = async () => {
    const res = await fetch('api/v1/apps');
    const apps = await res.json();
    store.set(apps);
}

store.patch = async (app) => {
    const res = await fetch(`api/v1/apps/${app._id}`, {
          method: 'PATCH', 
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(app)
      });
      if(res.ok) { 
          store.update(data => {
           return data.map(currentApp => currentApp._id === app._id ? app : currentApp)
          });
      };
      return {ok: res.ok, body: await res.json()};
}

store.post = async (app) => {
    const res = await fetch('api/v1/apps', {
        method: 'POST', 
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(app)
    });
    const body = await res.json();
    if(res.ok) {
        store.update(data => {
            const newData = [body, ...data];
            return newData;
        });
    }
    return {ok: res.ok, body};
}

export default store;
